// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3WrGb","amount":"Amount_amount__3LHFr","tip":"Amount_tip__Af599","tipHeader":"Amount_tipHeader__2Scpq","tipsWrap":"Amount_tipsWrap__295Dh"};